import React from "react";

interface Props {
  task: server.dto.UserTask
}

const TaskFull = ({ task }: Props) => {
  return <>
    <div>{task.title}</div>
    <div className="s1_small" dangerouslySetInnerHTML={{
      __html: task.body
    }}></div>
  </>;
};

export default TaskFull;